<template>
  <div>
    <div class="PaymentSuccessful">
      <div class="PaymentSuccessfulContent">
        <div>
          <div class="PaymentSuccessfulContent_icon"><img src="@a/img/sv107.svg" /></div>
          <div class="PaymentSuccessfulContent_title">{{ type }}</div>
          <div class="PaymentSuccessfulContent_btn notBlue" @click="back_home">前往机器人</div>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
export default {
  data() {
    return {
      type: ''
    };
  },
  components: {
    
  },
  methods: {
    back_home() {
      this.$router.push({path: '/alRobot'});
    },
  },
  mounted() {
    let type = this.$route.query.type;
    this.type= type;
  },
};
</script>


<style>
@import "NewAiRobotSuccessful.css";
</style>
